
import './App.css';

import React, {useState} from 'react'
import Navbar from './components/Navbar';
import Newscomponent from './components/Newscomponent';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import LoadingBar from 'react-top-loading-bar'

const App=()=> {
  const[progress,setProgress]=useState(0);
  
 
  
    return (
      <BrowserRouter>
        <div>
          <Navbar />
          <LoadingBar
          height={5}
            color="#f11946"
            progress={progress}
            
          />

          <Routes>
            <Route
              exact
              path="/"
              element={
                <Newscomponent setProgress = {setProgress}
                  key={"general"}
                  pageSize={5}
                  heading="General News"
                  country="in"
                  color="success"
                  category="general"
                />
              }
            ></Route>
            <Route
              exact
              path="/business"
              element={
                <Newscomponent setProgress = {setProgress}
                  key={"business"}
                  pageSize={5}
                  heading="Buisness Updates"
                  color="warning"
                  country="in"
                  category="business"
                />
              }
            ></Route>
            <Route
              exact
              path="/entertainment"
              element={
                <Newscomponent setProgress = {setProgress}
                  key={"entertainment"}
                  heading="Entertainment Blogs"
                  color="info"
                  pageSize={5}
                  country="in"
                  category="entertainment"
                />
              }
            ></Route>
            <Route
              exact
              path="/health"
              element={
                <Newscomponent setProgress = {setProgress}
                  key={"health"}
                  pageSize={5}
                  heading="Health News"
                  country="in"
                  color="danger"
                  category="health"
                />
              }
            ></Route>
            <Route
              exact
              path="/science"
              element={
                <Newscomponent setProgress = {setProgress}
                  key={"science"}
                  pageSize={5}
                  heading="Science Data"
                  country="in"
                  color="dark"
                  category="science"
                />
              }
            ></Route>
            <Route
              exact
              path="/sports"
              element={
                <Newscomponent setProgress = {setProgress}
                  key={"sports"}
                  pageSize={5}
                  heading="Sports Updates"
                  country="in"
                  color="primary"
                  category="sports"
                />
              }
            ></Route>
            <Route
              exact
              path="/technology"
              element={
                <Newscomponent setProgress = {setProgress}
                  key={"technology"}
                  heading="Technology Advancements"
                  pageSize={5}
                  color="secondary"
                  country="in"
                  category="technology"
                />
              }
            ></Route>
          </Routes>
        </div>
      </BrowserRouter>
    );
  }
export default App;
